import React, { useContext, useEffect, useState } from 'react';
import './planDetails.css';
import { Button, Divider, Typography } from '@mui/material';
import { InspectionCardsArray } from '../../utils/constants';
import { useLocation, Link as RouterLink } from 'react-router-dom';
import DoneIcon from '@mui/icons-material/Done';
import AddIcon from '@mui/icons-material/Add';
import Radio from '@mui/material/Radio';
import BuyNowComponent from '../../containers/buy-now/BuyNowComponent';
import FreeIcon from '../../assets/images/payment/freeIcon.png';
import BookInspectionModal from '../popups/BookInspectionModal';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { MyContext } from '../../context';
import BrandsCovered from '../popups/BrandsCovered';
import BrandsData from '../popups/BrandsData';

const PlanDetailsNew = () => {
  const { pageData, country, getInspectionPlans, tenantId, auth } =
    useContext(MyContext);

  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const transactionStatus = queryParams.get('TransactionStatus');
  useEffect(() => {
    if (transactionStatus) setStepperVisible(true);
  }, [transactionStatus]);
  const [inspectionPlanDetails, setInspectionPlanDetails] = useState();
  const [selectedValue, setSelectedValue] = useState('Standard');
  const [planDetails, setPlanDetails] = useState();
  const [activePlanDetails, setActivePlanDetails] = useState();
  const [packageData, setPackageData] = useState();
  const [totalAmount, setTotalAmount] = useState();
  const [inspectionCount, setInspectionCount] = useState(1);
  const [stepperVisible, setStepperVisible] = useState(false);
  const [pageDisable, setPageDisable] = useState(false);
  const [mobileDesignView, setMobileDesignVisible] = useState(false);
  const [isBrandsCovered, setIsBrandsCovered] = useState(false);
  const [OTP, setOTP] = useState('');
  const handleInspectionCountChange = (eve) => {
    setInspectionCount(eve.target.value);
    if (eve.target.value === '1')
      setPackageData(activePlanDetails?.smallPackage);
    else
      setPackageData(
        activePlanDetails?.highPackage
          ? activePlanDetails?.highPackage
          : activePlanDetails?.smallPackage
      );
  };

  const planName = queryParams.get('InspectionType')
    ? queryParams.get('InspectionType')
    : 'Standard';

  const handleChange = (event) => {
    let selectedPlan = inspectionPlanDetails?.filter((plan) =>
      plan?.packTitle.toLowerCase().includes(event.toLowerCase())
    );
    setActivePlanDetails(selectedPlan?.[0]);
    let pkgData = selectedPlan?.[0]?.smallPackage
      ? selectedPlan?.[0]?.smallPackage
      : selectedPlan?.[0]?.highPackage;
    setPackageData(pkgData);
    setTotalAmount(pkgData.totalPrice);
    setSelectedValue(event);
  };

  const handleInspectionAmount = (event) => {
    if (inspectionCount === 1) {
      setPackageData(
        event?.smallPackage ? event?.smallPackage : event?.highPackage
      );
      setTotalAmount(
        event?.smallPackage
          ? event?.smallPackage?.totalPrice
          : event?.highPackage?.totalPrice
      );
    } else {
      setPackageData(
        event?.highPackage ? event?.highPackage : event?.smallPackage
      );
    }
  };
  const handlePageDisable = () => {
    // setPageDisable(true);
  };

  const handleInputChange = (e) => {
    setOTP(e);
  };

  const handleBrandsCovered = () => {
    setIsBrandsCovered(true);
  };
  let planDataHandle = async () => {
    let inspectionData = await getInspectionPlans();
    const defaultPlan = planName
      ? inspectionData?.filter(
          (item) => item.packTitle?.toLowerCase() === planName?.toLowerCase()
        )
      : inspectionData?.[0];
    setInspectionPlanDetails(inspectionData);
    setPlanDetails(inspectionData);
    setActivePlanDetails(defaultPlan?.[0]);
    if (defaultPlan?.[0]?.smallPackage) {
      setPackageData(defaultPlan?.[0]?.smallPackage);
      setTotalAmount(defaultPlan?.[0]?.smallPackage?.totalPrice);
    } else if (defaultPlan?.[0]?.highPackage) {
      setPackageData(defaultPlan?.[0]?.highPackage);
      setTotalAmount(defaultPlan?.[0]?.highPackage?.totalPrice);
    }
  };
  useEffect(() => {
    planDataHandle();
    setStepperVisible(false);
  }, [country]);

  return (
    <section className="planDetails">
      <div
        id="inspection-plans"
        className="container inspection-plan-container"
      >
        {pageData?.planDetails?.header}
        <div className="inspection-plan-container-left">
          {/* <div className="inspection-plan-btn-container-mobile">
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                marginBottom: '5px',
              }}
            >
              <RouterLink
                style={{
                  color: '#003cc5',
                  fontSize: '18px',
                  border: '1px solid',
                  borderColor: '#003cc5',
                  padding: '5px',
                  borderRadius: '6px',
                }}
                target="_blank"
                to={'/sample-report'}
              >
                <p
                  style={{
                    color: 'rgb(0, 60, 197)',
                    fontFamily: 'matterThin',
                    fontSize: '16px',
                    paddingTop: '0px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                  }}
                >
                  {pageData?.planDetails?.sampleBtnText}
                  <OpenInNewIcon fontSize="small" />
                </p>
              </RouterLink>
            </div>
            <div
              className={'inspection-plan-card border-text'}
              disabled={pageDisable}
            >
              <div className="inspection-plan-card-header">
                {planDetails?.map((inspect, index) => (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Radio
                      checked={selectedValue === inspect?.packTitle}
                      onChange={() => handleChange(inspect?.packTitle)}
                      value={inspect?.packTitle}
                      name="radio-buttons"
                      inputProps={{ 'aria-label': 'A' }}
                      disabled={pageDisable}
                    />
                    <p
                      onClick={() => handleChange(inspect?.packTitle)}
                      className={
                        inspect?.packTitle === activePlanDetails?.packTitle
                          ? 'p-active'
                          : ''
                      }
                    >
                      {inspect?.packTitle}
                    </p>
                  </div>
                ))}
              </div>
              <div className="mobile-view-btn">
                <h6 style={{ color: '#003cc5', fontFamily: 'matterMedium' }}>
                  {pageData?.planDetails?.currency}{' '}
                  {activePlanDetails?.smallPackage?.totalPrice}
                </h6>
                <Button
                  sx={{
                    width: '60%',
                    height: '40px',
                    fontSize: '18px',
                    backgroundColor: '#003cc4',
                    borderRadius: 1,
                    textTransform: 'none',
                    fontFamily: 'matterMedium',
                    padding: '5px 5px',
                  }}
                  variant="contained"
                  disabled={pageDisable}
                  onClick={() => setMobileDesignVisible(true)}
                >
                  {pageData?.planDetails?.btnBookInspection}
                </Button>
              </div>
              <button
                className="bottom-text"
                style={{
                  border: 'none',
                  borderRadius: '6px',
                  color: '#003cc5',
                  cursor: 'pointer',
                }}
                onClick={() => handleBrandsCovered()}
                role="button"
                tabIndex={0}
              >
                <div
                  style={{
                    padding: '2px',
                    display: 'flex',
                    gap: '2px',
                    alignItems: 'center',
                  }}
                >
                  Brands Covered <OpenInNewIcon fontSize="small" />
                </div>
              </button>
            </div>
          </div> */}
          <div className="inspection-plan-btn-container-mbl">
            <div style={{ display: 'flex', gap: '20px' }}>
              {planDetails?.map((inspect, index) => (
                <div
                  key={index}
                  className={
                    inspect?.packTitle === activePlanDetails?.packTitle
                      ? 'inspection-plan-card-active border-text'
                      : 'inspection-plan-card border-text'
                  }
                  disabled={pageDisable}
                  onClick={() => handleInspectionAmount(inspect)}
                >
                  <div
                    className="inspection-plan-card-header"
                    onClick={() => handleChange(inspect?.packTitle)}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <p>{inspect?.packTitle}</p>
                    </div>
                    <p>
                      {pageData?.planDetails?.currency}{' '}
                      {inspectionCount == 1
                        ? inspect?.smallPackage?.totalPrice
                        : inspect?.highPackage?.totalPrice
                        ? inspect?.highPackage?.totalPrice
                        : inspect?.smallPackage?.totalPrice}
                    </p>
                    <p
                      style={{
                        color: 'black',
                        fontSize: '14px',
                        fontFamily: 'matter',
                        paddingBottom: '10px',
                      }}
                    >
                      {pageData?.planDetails?.noteTaxes}
                    </p>
                    <button
                      className="bottom-text"
                      style={{
                        border: 'none',
                        width: '90%',
                        borderRadius: '6px',
                        color: '#003cc5',
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'center',
                        // transform:
                        //   country === 'in'
                        //     ? 'translateX(20%)'
                        //     : 'translateX(0%)',
                      }}
                      onClick={() => handleBrandsCovered()}
                      role="button"
                      tabIndex={0}
                    >
                      <div
                        style={{
                          padding: '2px',
                          display: 'flex',
                          gap: '2px',
                          alignItems: 'center',
                          fontSize: '12px',
                        }}
                      >
                        {pageData?.planDetails?.brandsCovered}
                        <OpenInNewIcon className="openicon-mbl" />
                      </div>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="mobile-view-btn">
            {selectedValue && (
              <Button
                sx={{
                  width: '80%',
                  height: '40px',
                  fontSize: '20px',
                  backgroundColor: '#003cc4',
                  borderRadius: 1,
                  textTransform: 'none',
                  fontFamily: 'matterMedium',
                }}
                variant="contained"
                disabled={pageDisable}
                onClick={() => setMobileDesignVisible(true)}
              >
                {pageData?.planDetails?.btnBookInspection}
              </Button>
            )}
          </div>
          <div className="inspection-plan-btn-container ">
            <div style={{ display: 'flex', gap: '40px' }}>
              {planDetails?.map((inspect, index) => (
                <div
                  key={index}
                  className={
                    inspect?.packTitle === activePlanDetails?.packTitle
                      ? 'inspection-plan-card-active border-text'
                      : 'inspection-plan-card border-text'
                  }
                  disabled={pageDisable}
                  onClick={() => handleInspectionAmount(inspect)}
                >
                  <div
                    className="inspection-plan-card-header"
                    onClick={() => handleChange(inspect?.packTitle)}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <p>{inspect?.packTitle}</p>
                    </div>
                    <p>
                      {pageData?.planDetails?.currency}{' '}
                      {inspectionCount == 1
                        ? inspect?.smallPackage?.totalPrice
                        : inspect?.highPackage?.totalPrice
                        ? inspect?.highPackage?.totalPrice
                        : inspect?.smallPackage?.totalPrice}
                    </p>
                    <p
                      style={{
                        color: 'black',
                        fontSize: '14px',
                        fontFamily: 'matter',
                        paddingBottom: '10px',
                      }}
                    >
                      {pageData?.planDetails?.noteTaxes}
                    </p>
                    <button
                      className="bottom-text"
                      style={{
                        border: 'none',
                        borderRadius: '6px',
                        color: '#003cc5',
                        cursor: 'pointer',
                      }}
                      onClick={() => handleBrandsCovered()}
                      role="button"
                      tabIndex={0}
                    >
                      <div
                        style={{
                          padding: '2px',
                          display: 'flex',
                          gap: '2px',
                          alignItems: 'center',
                        }}
                      >
                        {pageData?.planDetails?.brandsCovered}
                        <OpenInNewIcon fontSize="small" />
                      </div>
                    </button>
                  </div>

                  <div className="mobile-view-btn">
                    {selectedValue === inspect?.packTitle && (
                      <Button
                        sx={{
                          width: '80%',
                          height: '40px',
                          fontSize: '20px',
                          backgroundColor: '#003cc4',
                          borderRadius: 1,
                          textTransform: 'none',
                          fontFamily: 'matterMedium',
                        }}
                        variant="contained"
                        disabled={pageDisable}
                        onClick={() => setMobileDesignVisible(true)}
                      >
                        {pageData?.planDetails?.btnBookInspection}
                      </Button>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div className="web-view-btn">
              <Button
                sx={{
                  width: '100%',
                  height: '50px',
                  fontSize: '20px',
                  backgroundColor: '#003cc4',
                  borderRadius: 1,
                  textTransform: 'none',
                  fontFamily: 'matterMedium',
                }}
                variant="contained"
                disabled={pageDisable}
                onClick={() => setStepperVisible(true)}
              >
                {pageData?.planDetails?.btnBookInspection}
              </Button>
              <p
                style={{
                  textAlign: 'center',
                  fontSize: '14px',
                  fontFamily: 'matterMedium',
                  color: '#e64a19',
                  paddingTop: '5px',
                }}
              >
                {pageData?.planDetails?.infoNote}
              </p>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                height: '100%',
                alignItems: 'flex-end',
              }}
            >
              <RouterLink
                style={{
                  color: '#003cc5',
                  fontSize: '18px',
                  border: '1px solid',
                  borderColor: '#003cc5',
                  padding: '5px',
                  borderRadius: '6px',
                }}
                target="_blank"
                to={'/sample-report'}
              >
                <p
                  style={{
                    color: 'rgb(0, 60, 197)',
                    fontFamily: 'matterThin',
                    fontSize: '16px',
                    paddingTop: '0px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                  }}
                >
                  {pageData?.planDetails?.sampleBtnText}
                  <OpenInNewIcon fontSize="small" />
                </p>
              </RouterLink>
            </div>
          </div>
        </div>
        {stepperVisible ? (
          <div className="inspection-plan-stepper-container">
            {/* <ArrowCircleLeftIcon /> */}
            <div className="inspection-plan-stepper-body">
              <BuyNowComponent
                selectedValue={selectedValue}
                packageData={packageData}
                inspectionPlanDetails={inspectionPlanDetails}
                inspectionCount={inspectionCount}
                setStepperVisible={() => setStepperVisible(false)}
                totalAmount={totalAmount}
                setPageDisable={handlePageDisable}
              />
            </div>
          </div>
        ) : (
          <div className="inspection-plan-card-container">
            {pageData?.planDetails?.inspectionCardsArray?.map((item, index) => {
              return (
                <div key={index} className="inspection-card">
                  <h6 className="inspection-card-header">
                    <span>{item?.header}</span>
                    <div className="inspection-card-header-right">
                      {index == 3 ? (
                        <img
                          loading="lazy"
                          src={FreeIcon}
                          // style={{ width: '30px', height: '30px' }}
                        />
                      ) : (
                        <>
                          <p
                            style={{
                              backgroundColor: 'rgb(236, 247, 249)',
                              padding: '5px',
                              color: '#003cc5',
                              width: '50px',
                              textAlign: 'center',
                              fontFamily: 'matterMedium',
                            }}
                          >
                            {item?.checkPoints}
                          </p>
                          <p
                            style={{
                              fontSize: '12px',
                              paddingTop: '0px',
                              fontFamily: 'matterThin',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            Check Points
                          </p>
                        </>
                      )}
                    </div>
                  </h6>
                  <Divider
                    style={{
                      borderColor: '#25632d',
                      // borderWidth: '2px',
                      marginBottom: '5px',
                      marginTop: '5px',
                    }}
                  />
                  <div className="inspection-card-list-items">
                    {item?.inspectionItems.map((feature, subIndex) => (
                      <Typography key={subIndex + 1}>
                        <span
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            flexWrap: 'nowrap',
                            fontFamily: 'matterMedium',
                            flexDirection: 'row',
                            gap: '5px',
                            color: '#003cc5',
                          }}
                        >
                          <DoneIcon className={'circle-tick-2'} />
                          {feature}
                        </span>
                      </Typography>
                    ))}
                  </div>

                  <div className="inspection-card-additional-items">
                    {
                      <>
                        <Typography
                          sx={{
                            color: '#003cc5',
                            fontSize: '18px',
                            fontFamily: 'matterMedium',
                          }}
                        >
                          {item?.additionalBenifits?.header}
                        </Typography>
                        {item?.additionalBenifits?.data?.map((itemBenifit) => (
                          <Typography className="additional-details-item">
                            <span>
                              <div style={{ marginTop: '5px' }}>
                                <AddIcon
                                  className={'circle-tick-2'}
                                  fontSize="small"
                                />
                              </div>
                              {itemBenifit}
                            </span>
                          </Typography>
                        ))}
                      </>
                    }
                  </div>
                </div>
              );
            })}
            <BookInspectionModal
              selectedValue={selectedValue}
              packageData={packageData}
              open={mobileDesignView}
              handleClose={() => setMobileDesignVisible(false)}
              content="test"
              pageData={pageData}
              country={country}
              auth={auth}
              tenantId={tenantId}
            />
          </div>
        )}
        {isBrandsCovered && (
          <BrandsCovered
            open={isBrandsCovered}
            onClose={() => setIsBrandsCovered(!isBrandsCovered)}
            title={pageData?.planDetails?.brandCoveredHeader}
            children={<BrandsData pageData={pageData?.planDetails} />}
          />
        )}
      </div>
    </section>
  );
};

export default PlanDetailsNew;
